<template>
  <div id="main-content" class="detail-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.class') }}:</span>
            <span class="info-span"> {{ classInfo ? classInfo.name : '' }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.grade') }}:</span>
            <span class="info-span"> {{ classInfo ? classInfo.grade : ''}} </span>
          </el-col>
        </el-row>
<!--        <el-row class="row-section">-->
<!--          <span style="line-height: 40px; margin-left: 20px; font-size: 25px;">{{ $t('class_detail.class_end_time_by_date') }}</span>-->
<!--        </el-row>-->

<!--        <div :class="{ 'is-hide' : !isShowMore }">-->
<!--          <div v-for="(item, index) in sortedTimeList" :key="index">-->
<!--            <el-row v-if="dateShowMore === item.date" class="show-more-section">-->
<!--                <span @click="toggleShowMore()">-->
<!--                  {{ !isShowMore ? $t('common.show_more') : $t('common.hide') }}-->
<!--                </span>-->
<!--            </el-row>-->
<!--            <el-row style="padding-top: 20px" :class="{ 'is-past': isPast(item)}">-->
<!--              <el-col :span="11" style="display: inline">-->
<!--                <span class="form-lable">{{ $t('common.date') }}:</span>-->
<!--                <span class="info-span"> {{ item.date }} </span>-->
<!--              </el-col>-->
<!--              <el-col :offset="1" :span="12" style="display: inline">-->
<!--                <span class="form-lable">{{ $t('common.end_time') }}:</span>-->
<!--                <span class="info-span"> {{ item.time }} </span>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </div>-->
<!--        </div>-->
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailClass",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/classroom?action=back`,
        title: 'class_detail.class_information',
        isShowMore: false
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        class_id: this.$route.query.cid
      }
      this.$store.dispatch('classroom/getClassInfo', payload)
    },
    computed: {
      ...mapState('classroom', ['classInfo']),
      sortedTimeList: function () {
        //
        // let sortedTimeList = [].concat(this.classInfo ? this.classInfo.drop_time_list : [])
        //
        // sortedTimeList.sort((before, after) => {
        //   return before.date < after.date ? 1 : -1
        // })
        //
        // return sortedTimeList
      },
      dateShowMore: function () {
        // let date = null
        // let currentDate = this.$moment().format('YYYY-MM-DD')
        //
        // this.sortedTimeList.forEach((item) => {
        //   if (item.date < currentDate && !date) {
        //     date = item.date
        //   }
        // })
        //
        // return date
      }
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/classroom/edit', query: {cid: this.$route.query.cid}});
      },
      isPast (item) {
        let currentDate = this.$moment().format('YYYY-MM-DD')

        return item.date < currentDate
      },
      toggleShowMore: function () {
        this.isShowMore = !this.isShowMore
      }
    }
  }
</script>

<style lang="scss">
  .detail-class {
    .show-more-section {
      text-align: left;
      margin-top: 20px;

      span {
        color: #409EFF;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .is-hide {
      .is-past {
        display: none;
      }
    }
  }
</style>
